import { HTML, CSS, Bootstrap, JavaScript, JQuery, ReactJS, NextJS, RemixJS, Redux, TypeScript, TailwindCSS, MaterialUI, GSAP, SASS, Expo, ReactNative, NodeJS, ExpressJS, MongoDB, MySQL, PHP, Supabase, Appwrite, Firebase, C, CPP, Git, Github, Azure, VSCode, Postman, Figma } from './assets/export';
import { PLSLawyers, DcodeBlock, FoundationalAI, Webexcep, GirlScript, Hack2Skill } from './assets/export';
import { OKIMR, Excellence, Alpha } from './assets/export';
import { AnshulEstate, AppleIPhone, HooBank, Gpt3, Anon, Hotstar, GardenCafe, Fithub } from './assets/export';


export const Bio = {
  name: "Anshul Gupta",
  roles: ["Full-Stack Developer", "Freelancer"],
  description: "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  resume: "https://drive.google.com/file/d/1Sbr1Oeferv47EEeCJItwiqd-A_fk3BAj/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/anshulgupta48/",
  github: "https://github.com/anshulgupta48",
  leetcode: "https://leetcode.com/anshulgupta48/",
  geeksforgeeks: "https://auth.geeksforgeeks.org/user/anshulgupta48",
  instagram: "https://www.instagram.com/anshulgupta.web/",
  whatsapp: "https://wa.me/9926263736?text=Hi Anshul! I'd like to know more about your services."
};


export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "HTML", image: HTML },
      { name: "CSS", image: CSS },
      { name: "Bootstrap", image: Bootstrap },
      { name: "JavaScript", image: JavaScript },
      { name: "JQuery", image: JQuery },
      { name: "React JS", image: ReactJS },
      { name: "Next JS", image: NextJS },
      { name: "Remix JS", image: RemixJS },
      { name: "Redux", image: Redux },
      { name: "TypeScript", image: TypeScript },
      { name: "Tailwind CSS", image: TailwindCSS },
      { name: "Material UI", image: MaterialUI },
      { name: "GSAP", image: GSAP },
      { name: "SASS", image: SASS },
      { name: "Expo", image: Expo },
      { name: "React Native", image: ReactNative }
    ]
  },

  {
    title: "Backend",
    skills: [
      { name: "Node JS", image: NodeJS },
      { name: "Express JS", image: ExpressJS },
      { name: "MongoDB", image: MongoDB },
      { name: "MySQL", image: MySQL },
      { name: "PHP", image: PHP },
      { name: "Supabase", image: Supabase },
      { name: "Appwrite", image: Appwrite },
      { name: "Firebase", image: Firebase }
    ]
  },

  {
    title: "Languages",
    skills: [
      { name: "C", image: C },
      { name: "C++", image: CPP },
      { name: "JavaScript", image: JavaScript },
      { name: "TypeScript", image: TypeScript },
    ]
  },

  {
    title: "Others",
    skills: [
      { name: "Git", image: Git },
      { name: "Github", image: Github },
      { name: "Microsoft Azure", image: Azure },
      { name: "VS Code", image: VSCode },
      { name: "Postman", image: Postman },
      { name: "Figma", image: Figma }
    ]
  }
];


export const experiences = [
  {
    img: PLSLawyers,
    role: "Frontend Developer",
    company: "PLS Lawyers",
    date: "July 2024 - Present",
    desc: null,
    skills: null,
    doc: ""
  },
  {
    img: DcodeBlock,
    role: "Frontend Developer Intern",
    company: "DcodeBlock",
    date: "June 2024 - July 2024",
    desc: "Designed and implemented modular components from scratch, replacing legacy code to enhance security and reduce technical debt by 50%. Improved platform performance through optimized frontend implementation, reducing rendering times by 20%. Strengthened security protocols, mitigating potential vulnerabilities and improving platform integrity by 40%. Partnered with web3 developers, backend teams, and UI/UX designers to deliver a cohesive and user-centric platform.",
    skills: ["HTML", "CSS", "Bootstrap", "JavaScript", "ReactJS", "Tailwind CSS", "GSAP", "SASS"],
    doc: ""
  },
  {
    img: FoundationalAI,
    role: "Frontend Developer Intern",
    company: "Foundational AI",
    date: "Dec 2023 - May 2024",
    desc: "Developed a CRM-integrated Outlook plugin to automate email workflows, enabling businesses to respond to customers in a single click, leading to a 30% increase in response efficiency. Designed and built Foundational AI's main website, improving SEO performance by 45%. Developed a multi-functional platform to manage Outlook plugin operations, introducing WhatsApp Business message scheduling, driving a 25% increase in premium subscriptions. Improved application performance by optimizing code and implementing best practices, reducing page load times by 20%. Collaborated with cross-functional teams to ensure seamless integration of frontend designs with backend services, maintaining a 99% uptime rate for all deployed features.",
    skills: ["HTML", "CSS", "JavaScript", "ReactJS", "Redux", "NextJS", "Material UI", "GSAP", "SCSS"],
    doc: ""
  },
  {
    img: Webexcep,
    role: "Frontend Developer Intern",
    company: "Webexcep",
    date: "Sep 2023 - Nov 2023",
    desc: "Designed and deployed responsive websites, enhancing online presence for small to medium-sized businesses and boosting user engagement by 25%. Built and launched Webexcep's main business website, achieving a 30% improvement in site performance and SEO rankings through optimized development practices. Ensured seamless cross-browser compatibility and responsiveness across devices, reducing reported UI issues by 40%. Collaborated with cross-functional teams to deliver high-quality websites with a focus on performance, scalability, and user experience.",
    skills: ["HTML", "CSS", "Bootstrap", "JavaScript", "ReactJS", "Redux", "Tailwind CSS", "Material UI", "GSAP"],
    doc: ""
  },
  {
    img: GirlScript,
    role: "Open Source Contributor",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Aug 2023",
    desc: "Collaborated on open-source frontend projects, fixing bugs and responsive design elements, enhancing functionality by 30%. Improved code quality and scalability by refactoring legacy components of open-source projects, ensuring long-term maintainability. Collaborated with a distributed team of contributors to deliver scalable, well-documented codebases for community-driven applications.",
    skills: ["HTML", "CSS", "Bootstrap", "JavaScript", "ReactJS"],
    doc: ""
  },
  {
    img: Hack2Skill,
    role: "Open Source Contributor",
    company: "Hack2Skill",
    date: "Jun 2023 - Jul 2023",
    desc: "Contributed to open-source projects focusing on interactive UI elements, increasing user retention and satisfaction by 20%. Improved code quality and scalability by refactoring legacy components of open-source projects, ensuring long-term maintainability. Partnered with developers across the globe to contribute scalable solutions and adhere to industry best practices.",
    skills: ["HTML", "CSS", "Bootstrap", "JavaScript", "ReactJS"],
    doc: ""
  }
];


export const education = [
  {
    img: OKIMR,
    school: "Om Kothari Institute of Management & Research, Kota",
    date: "Sep 2022 - Jun 2025",
    grade: "80%",
    desc: "I am currently pursuing a Bachelor's degree in Computer Application at Om Kothari Institute of Management & Research, Kota, where I am honing my skills in computer science and information technology. This program is equipping me with the knowledge and expertise required to thrive in the dynamic field of technology and software development.",
    degree: "BCA (Bachelor in Computer Application)"
  },
  {
    img: Excellence,
    school: "Govt. Excellence School, Sheopur",
    date: "Jul 2021 - Jun 2022",
    grade: "87.40%",
    desc: "I completed my 12th-grade education at Government Excellence School, Sheopur, with a strong focus on Physics, Chemistry, and Mathematics (PCM). This experience laid the foundation for my academic journey, equipping me with essential problem-solving skills and a passion for the sciences.",
    degree: "12th - PCM"
  },
  {
    img: Alpha,
    school: "Alpha Higher Secondary School, Sheopur",
    date: "Jul 2019 - Jun 2020",
    grade: "90.33%",
    desc: "I completed my 10th-grade education at Alpha Higher Secondary School, where I acquired a solid educational foundation and developed valuable study habits that would serve me well in subsequent academic endeavors",
    degree: "10th"
  }
];


export const projects = [
  {
    title: "Anshul-Estate WebApp",
    description: "Developed a fully responsive Real-Estate web application using Vite JS, Node JS, Express JS, MongoDB, Firebase, Redux, Tailwind CSS. Implemented JWT for secure authentication and bcryptjs for password encryption, enhancing the security and integrity of user data. Utilized Firebase for user authentication and MongoDB for efficient and scalable data storage, ensuring robust backend support.",
    image: AnshulEstate,
    tags: ["Vite JS", "Node JS", "Express JS", "MongoDB", "Firebase", "Redux", "Tailwind CSS"],
    github: "https://github.com/anshulgupta48/Anshul-Estate-WebApp",
    link: "https://mern-estate-webapp.onrender.com/",
  },
  {
    title: "Apple IPhone Website",
    description: "Developed a Apple IPhone Website Clone that offers a Unique and Engaging Experience to their users. It Has 5 Sections - Hero, Highlights, IPhone Model, Features, How it Works Section. It is a fully responsive website developed using Vite JS, Tailwind CSS, GSAP and Three JS.. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, it ensures a smooth browsing experience.",
    image: AppleIPhone,
    tags: ["Vite JS", "Tailwind CSS", "GSAP", "Three JS"],
    github: "https://github.com/anshulgupta48/Apple-IPhone-Clone",
    link: "https://apple-iphone-website-one.vercel.app/",
  },
  {
    title: "Hoobank Website",
    description: "Developed a Real-World Bank Website named 'Hoobank' that offers a Unique and Engaging Experience to their users. It Has 4 Sections - Home, Features, Products & Clients Section. 'Hoobank' is a fully responsive website developed using Vite JS and Tailwind CSS. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, 'Hoobank' ensures a smooth browsing experience.",
    image: HooBank,
    tags: ["Vite JS", "Tailwind CSS"],
    github: "https://github.com/anshulgupta48/Hoobank-Website",
    link: "https://anshulgupta48.github.io/Hoobank-Website",
  },
  {
    title: "GPT3-OpenAI Website",
    description: "'GPT3-OpenAI' is a Real-World AI-Tool Website that offers you a collection of informative articles that dive deep into the world of AI. It Has 5 Sections - Home, What is GPT3, Features, Possibility & Blogs Section from Where is Created to Provide a Unique and Engaging experience. 'GPT3-OpenAI' is a fully responsive website developed using React JS and Sass. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, 'GPT3-OpenAI' ensures a smooth browsing experience.",
    image: Gpt3,
    tags: ["React JS", "Sass"],
    github: "https://github.com/anshulgupta48/GPT3-OpenAI-Website",
    link: "https://anshulgupta48.github.io/GPT3-OpenAI-Website",
  },
  {
    title: "Anon Ecommerce Website",
    description: "Designed and Developed a Real-World Ecommerce Website named 'Anon' that offers a wide range of products and features to enhance your online shopping experience. It Has 6 Sections - Categories, Deals of the Day, Recommended For You, Electronics, Our Founder & Services, Blogs Section. 'Anon' is a fully responsive website developed using HTML, CSS and JavaScript. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, 'Anon' ensures a smooth browsing experience.",
    image: Anon,
    tags: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/anshulgupta48/Anon-Ecommerce-Website",
    link: "https://anshulgupta48.github.io/Anon-Ecommerce-Website",
  },
  {
    title: "Disney+ Hotstar Clone",
    description: "I Have Created a 'Disney Plus Hotstar' Clone. It is a fully responsive website developed using HTML, CSS and JavaScript. It Has 3 Sections - Recommended For You, Popular Shows, New Releases from where Users Can Navigate to their Favourite Shows. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, it ensures a smooth browsing experience.",
    image: Hotstar,
    tags: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/anshulgupta48/Disney-Plus-Hotstar-Clone",
    link: "https://anshulgupta48.github.io/Disney-Plus-Hotstar-Clone",
  },
  {
    title: "The Garden Cafe Website",
    description: "Designed and Developed a Real-World Cafe Website named 'The Garden Cafe' that promises an immersive and enchanting online experience. 'The Garden Cafe' is a fully responsive website developed using HTML, CSS and JavaScript. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, 'The Garden Cafe' ensures a smooth browsing experience.",
    image: GardenCafe,
    tags: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/anshulgupta48/The-Garden-Cafe-Website",
    link: "https://anshulgupta48.github.io/The-Garden-Cafe-Website",
  },
  {
    title: "Fithub Gym Website",
    description: "'Fithub' is a Real-World Gym Website Which offers a comprehensive fitness experience for users. 'Fithub' is a fully responsive website developed using HTML, CSS and JavaScript. It Has 4 dynamic pages including Home, About, Classes, and Contact. Regardless of the device you use, be it a desktop computer, tablet, or smartphone, 'Fithub' ensures a smooth browsing experience.",
    image: Fithub,
    tags: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/anshulgupta48/Fithub-Gym-Website",
    link: "https://anshulgupta48.github.io/Fithub-Gym-Website",
  }
];